export default "__VITE_ASSET__969b7488__"